(function () {
	'use strict';

	try{if(typeof document != 'undefined'){var elementStyle = document.createElement('style');elementStyle.appendChild(document.createTextNode("._label_l0xdc_1 {\n    color: var(--axa-fr-text-primary);\n    font-family: var(--font-family);\n    font-size: 2.4rem;\n    font-weight: 600;\n    margin-bottom: var(--axa-fr-spacing-03);\n}\n._inputGroup_145i1_1 {\n    margin: 0;\n    padding: 0;\n    width: 100%;\n}\n\n._inputGroupGrid_145i1_7 {\n    display: grid;\n    grid-gap: 0.8rem;\n    grid-template-columns: repeat(auto-fill, minmax(14.4rem, 1fr));\n}\n\n._inputGroupStacked_145i1_13 {\n    display: flex;\n    flex-direction: column;\n    gap: 0.8rem;\n}\n\n@media only screen and (min-width: 668px) {\n    ._inputGroupGrid_145i1_7 {\n        grid-gap: 1.6rem;\n        grid-template-columns: repeat(auto-fill, minmax(18.6rem, 1fr));\n    }\n\n    ._inputGroupStacked_145i1_13 {\n        gap: 1.6rem;\n    }\n}\n\n._inputRadio_145i1_30 {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    padding: 1.6rem;\n    width: 100%;\n    min-height: 6.4rem;\n\n}\n\n._inputRadio_145i1_30 label {\n    cursor: pointer;\n    font-weight: 600;\n    margin: 0;\n    font-size: 1.6rem;\n    line-height: 2.4rem;\n    padding: 0.8rem 2.4rem;\n    text-align: center;\n}\n\n._inputRadio_145i1_30[aria-checked='true'] label,\n._inputRadio_145i1_30:hover label {\n    color: var(--axa-fr-border-select);\n}"));document.head.appendChild(elementStyle);}}catch(e){console.error('vite-plugin-css-injected-by-js', e);}

})();
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import { SelectableGroup, Selectable } from '@axa-fr-axion/selectable';
import classNames from 'classnames';
import { useId } from 'react';

const label = "_label_l0xdc_1";
const styles$1 = {
	label: label
};

function GroupInputRadioLabel({ id, className, title }) {
  return /* @__PURE__ */ jsx(
    "div",
    {
      id,
      className: classNames(styles$1.label, className),
      children: title
    }
  );
}

const inputGroup = "_inputGroup_145i1_1";
const inputGroupGrid = "_inputGroupGrid_145i1_7";
const inputGroupStacked = "_inputGroupStacked_145i1_13";
const inputRadio = "_inputRadio_145i1_30";
const styles = {
	inputGroup: inputGroup,
	inputGroupGrid: inputGroupGrid,
	inputGroupStacked: inputGroupStacked,
	inputRadio: inputRadio
};

const GroupInputRadio = ({
  dataInput,
  label,
  labelClassName,
  layout = "grid",
  ...groupProps
}) => {
  const groupLabelId = useId();
  let containerClassName = styles.inputGroupGrid;
  if (layout === "stacked") {
    containerClassName = styles.inputGroupStacked;
  }
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    label && /* @__PURE__ */ jsx(
      GroupInputRadioLabel,
      {
        id: groupLabelId,
        title: label,
        className: labelClassName
      }
    ),
    /* @__PURE__ */ jsx(
      SelectableGroup,
      {
        ...groupProps,
        className: classNames(styles.inputGroup, containerClassName),
        labelledby: groupLabelId,
        children: dataInput.map((input) => /* @__PURE__ */ jsx(
          Selectable,
          {
            className: styles.inputRadio,
            value: input.value,
            labelledby: `${groupLabelId}${input.value}`,
            children: /* @__PURE__ */ jsx("label", { id: `${groupLabelId}${input.value}`, children: input.label })
          },
          input.value
        ))
      }
    )
  ] });
};

export { GroupInputRadio, GroupInputRadioLabel };
